export default "__VITE_ASSET__CbDaSV3g__"